// @ts-strict-ignore
import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnInit
} from '@angular/core';
import { AppConstants } from '@utils/app.constants';

@Directive({
  selector: 'label[lm-label]', // tslint:disable-line
  exportAs: 'lm-label'
})
export class LMLabelDirective implements OnInit, AfterViewInit {
  @Input() layoutField: LMFormLayoutField;
  @Input() layoutInfo: LMFormLayoutInfo;
  @Input() lmColumnLayoutInfo: LMColumnLayoutInfo;
  @Input() lmParagraphLayoutInfo: LMParagraphLayoutInfo;
  @Input() parentIsFormLayout: boolean;
  @Input() id: string;
  @Input() displayInlineBlock = false;
  @Input() checkBoxIsDisplayAsText = false;
  /**
   * used to set the foreground color when an upper element has
   * a class of `personalize-header` that has a parent element
   * with a class of `is-personalizable`
   */
  @HostBinding('class.personalize-text') @Input() personalize = false;
  @Input() isCompoundFieldMember = false;

  private label: LMLabelLayout;

  constructor(private elementRef: ElementRef) {
  }

  @HostBinding('class.lm-number-label') isNumberLabel = false;

  @HostBinding('class.lm-no-label') isNoLabel = false;

  @HostBinding('class.lm-paragraph-no-label') hasNoVisibleLabels = false;

  @HostBinding('class.no-colon') isNoColon = false;

  ngOnInit() {
    if (this.layoutField) {
      this.label = <LMLabelLayout>this.layoutField.label;
    }

    this.isNumberLabel = this.layoutField && this.layoutField.numberLabel;

    // No label if form text in a single column
    if (this.layoutField?.type?.toUpperCase() === AppConstants.FORMTEXT && this.lmColumnLayoutInfo?.nbrColumns === 1) {
      this.isNoLabel = true;
    } else if (this.layoutField?.labelSuppressed) {
      this.isNoLabel = true;
    }  else if (this.layoutField?.mouseOverText) {
      this.isNoLabel = false;
    } else {
      this.isNoLabel = !!this.label?.nolabel;
    }

    this.hasNoVisibleLabels = this.lmParagraphLayoutInfo && !this.lmParagraphLayoutInfo.hasVisibleLabels;

    // No Colon processing
    if (this.lmParagraphLayoutInfo && !this.isCompoundFieldMember) {
      // Exclude paragraph layouts
      this.isNoColon = false;
    } else if ((this.layoutField && this.layoutField.type && this.layoutField.type.toUpperCase()) === AppConstants.FORMTEXT
          && (this.lmColumnLayoutInfo && this.lmColumnLayoutInfo.nbrColumns === 1)) {
      // No label if form text in a single column
      this.isNoColon = true;
    } else {
      this.isNoColon = this.label?.noColon;
    }
  }

  ngAfterViewInit() {
    if (this.lmColumnLayoutInfo) {
      if (this.lmColumnLayoutInfo && this.elementRef && (this.lmColumnLayoutInfo.imageInFirstColumn || this.lmColumnLayoutInfo.distributed)) {
        this.elementRef.nativeElement.setAttribute('title', this.elementRef.nativeElement.textContent);
      }
    }
  }
}
